import React from 'react'
import { useSelector } from 'react-redux'

const UnitMeasureShortText = ({ unitMeasure }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)

  return (
    <p>
        {
            unitMeasure && unitMeasures[unitMeasure] ?
                unitMeasures[unitMeasure].name
            :
                '?'
        }
    </p>
  )
}

export default UnitMeasureShortText